import { createSlotRecipe } from './runtime';

const sidebarConfig = {"name":"sidebar","slots":["root","head","brand","mark","wordmark","name","product","toggle","nav","group","groupLabel","list","link","rail","icon","label","footer"],"defaultVariants":{"collapsed":false},"variantMap":{"collapsed":["false","true"]}}

export const sidebar = /* @__PURE__ */ createSlotRecipe(sidebarConfig)